import React, {useContext, useEffect, useState} from 'react';
import './FeedItemCard.css';
import {MapViewContext} from "../contexts/MapViewContext";

type FeedItem = {
    state_id: string;
    resolved_name?: string;
    categories_primary_id?: string;
    categories_primary_name?: string;
    hours?: string;
    address?: string;
    media_keys?: string[];
    saves?: number;
    description?: string;
    slug?: string;
    color?: string;
};

interface Props {
    item: FeedItem;
}

const FeedItemCard: React.FC<Props> = ({item}) => {
    const images = item.media_keys || [];
    const [index, setIndex] = useState(0);
    const { setHoveredStateId } = useContext(MapViewContext);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (!images[index]) return;

        const img = new Image();
        img.src = imageUrl(images[index]);

        img.onload = () => setIsLoading(false);
        img.onerror = () => setIsLoading(false);

        setIsLoading(true); // reset when index/image changes

        return () => {
            img.onload = null;
            img.onerror = null;
        };
    }, [index, images]);

    const imageUrl = (key: string) =>
        `https://calendre.imgix.net/${key}?w=384&h=430&dpr=2&fit=crop&fm=pjpg&q=40`;

    const handlePrev = () =>
        setIndex((prev) => (prev - 1 + images.length) % images.length);
    const handleNext = () =>
        setIndex((prev) => (prev + 1) % images.length);

    return (
        <div className="feed-card-outer-wrapper"
             onMouseEnter={() => setHoveredStateId(item.state_id)}
             onMouseLeave={() => setHoveredStateId(null)}
        >
            <div className="feed-card-wrapper">
                <div
                    className="feed-image"
                    style={{backgroundImage: images[index] ? `url(${imageUrl(images[index])})` : 'none'}}
                >
                    {isLoading && (
                        <div className="feed-image-spinner">
                            <div className="spinner" />
                        </div>
                    )}
                    {images.length > 1 && (
                        <div className="image-progress">
                            <div className="image-counter">{`${index + 1}/${images.length}`}</div>
                            <div className="image-icon">
                                <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                                    <g fill="none" stroke="#FFFFFF">
                                        <rect x="0" y="0" width="13.547" height="13.547" rx="2"
                                              transform="translate(1 1)"/>
                                        <polygon strokeLinejoin="round"
                                                 points="3 12.451 5.685 6 8.701 11.302 10.415 8.445 13.12 12.451"
                                                 transform="translate(-1 -1)"/>
                                        <circle cx="9.521" cy="4.521" r="1.521" transform="translate(-1 -1)"/>
                                    </g>
                                </svg>
                            </div>
                        </div>
                    )}
                </div>

                <div className="feed-card">
                    <div className="feed-overlay"/>

                    <div className="feed-header">
                        {item.categories_primary_name && (
                            <div
                                className="tag-bubble"
                                style={{backgroundColor: item.color || '#59e2f5'}}
                            >
                                {item.categories_primary_name}
                            </div>
                        )}
                        <h4 className="card-title">{item.resolved_name}</h4>

                        <div className="hours-and-view">
                            {item.address && <span className="open-hours">{item.address}</span>}
                        </div>
                    </div>

                    {images.length > 1 && (
                        <>
                            <div className="nav left" onClick={handlePrev}>‹</div>
                            <div className="nav right" onClick={handleNext}>›</div>
                        </>
                    )}

                    {item.slug && (<div className="feed-footer">
                        <div className="footer-description">{item.slug}</div>
                    </div>)}
                </div>
            </div>
        </div>
    );
};

export default FeedItemCard;
